import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  BibliographicResourceType,
  OnlineResourceUrl,
  OnlineResourceUrlType,
} from '®shared/bibliographic-resource';
import { AppConfig } from '®shared/config';
import {
  ExternalLinkClickEvent,
  LinkPositionOnPage,
  getOnlineResourceEventProperties,
} from '®shared/list-item/events';
import { PlayerResourceUtils } from '®shared/player-resource';
import { UriService } from '®shared/url-utils';

@Component({
  selector: 'rl-digital-copy',
  templateUrl: './digital-copy.component.html',
})
export class DigitalCopyComponent {
  OnlineResourceUrlType = OnlineResourceUrlType;
  hideDoiLinks = false;

  @Input() onlineResource: OnlineResourceUrl;
  @Input() resourceType: BibliographicResourceType;
  @Output() onlineResourceClick = new EventEmitter<ExternalLinkClickEvent>();

  constructor(private appConfig: AppConfig, private uriService: UriService) {
    this.hideDoiLinks = this.appConfig.tenant.library.hideDoiLinks;
  }

  relativeToBaseUri(externalLink: string): string {
    return this.uriService.getExternalLinkRelativeToBaseUri(externalLink);
  }

  get normalisedResourceType(): string | null {
    return this.resourceType ? this.resourceType.toLowerCase() : null;
  }

  get isPlayerLink(): boolean {
    return PlayerResourceUtils.isPlayerUrl(this.onlineResource.original_url);
  }

  trackExternalLinkClick(): void {
    this.onlineResourceClick.emit(
      getOnlineResourceEventProperties(
        this.onlineResource,
        this.isPlayerLink,
        LinkPositionOnPage.ITEM_AVAILABILITY_SECTION,
      ),
    );
  }
}
